import {GxButton, GxIcon, GxSpinner, GxTextarea} from '@garpix/garpix-web-components-react';
import cnBind from 'classnames/bind';
import {useFormik} from 'formik';
import dayjs from 'dayjs';
import React, {FC, useCallback, useContext, useEffect, useState} from 'react';
import {useStoreon} from 'storeon/react';
import 'react-responsive-modal/styles.css';
import { Events, State } from '@/interfaces';
import { TLabelAndValue } from '@/types';
import { toast } from 'react-toastify';
import {IndicatorIcon} from '../../../../../assets';
import Button from '../../../../../components/Button';
import Clipboard from '../../../../../components/Clipboard';
import Input from '../../../../../components/Input';
import InputNumbers from '../../../../../components/InputNumbers';
import Radio from '../../../../../components/Radio';
import Switcher from '../../../../../components/Switcher';
import styles from './styles/index.module.scss';
import {ContextDeposit, initialValuesDepositsOrCertificate, SIDEBAR_TYPES, TYPES} from '../const';
import {priceInfo} from '../helpers';
import {convertTimeToIntegerMinutes, handleOnPressKey, definePayLinkTtl} from '../../../helpers';
import { TYPE_USER, TYPES_DEPOSITS } from '../../../../../const';
import {checkAutomaticStockOrder, checkManualStockOrder, checkPromoCode} from '../../ModalOrder/helpers';
import ManualStock from '../../../../../components/ManualStock';
import {IBasket} from '../interfaces';

// Функция валидации номера и серии сертификата
const validateCertificateNumber = (value: string): boolean => {
    if (!value || value === '') return true; // Пустое значение допустимо
    // Регулярное выражение позволяет: кириллица, латиница, цифры, слеш (/), тире (-), нижнее подчеркивание (_)
    const regex = /^[a-zA-Zа-яА-ЯёЁ0-9\-_/]+$/;
    return regex.test(value);
};

const Basket: FC<IBasket> = ({activeItem, count, userId, handleClickOnline, activeSideBarItem, modalClose, setModalFlag, activeHeaderItem}) => {

    const [flagSpinner, setFlagSpinner] = useState(false);
    const toggleFlagSpinner = useCallback(() => setFlagSpinner((prev) => !prev), []);
    const {currentUser, typeOrder} = useStoreon<State, Events>('currentUser', 'typeOrder');
    const date = dayjs().format('YYYY.MM.DD HH:mm');
    const [isBill, stockInfo, setStockInfo] = useContext<any>(ContextDeposit);
    const cn = cnBind.bind(styles);

    const payHere = () => {
        setModalFlag({
            price: Math.abs(Math.trunc(formik.values.base_price)),
            stock: price_stock,
            price_total,
            stock_id: formik.values.stock,
            minutes: activeItem ? Math.trunc(activeItem.minutes) * count : 0,
            resource: formik.values.resource,
            type: formik.values.is_pay_here,
            certificate_party: formik.values.certificate_party,
            comment: formik.values.comment,
            number_series: formik.values.number_series,
            set_number_series: formik.values.set_number_series,
        });
    };

    // Обработчик изменения номера/серии с валидацией
    const handleNumberSeriesChange = (field: 'number' | 'series', value: string) => {
        if (validateCertificateNumber(value)) {
            formik.setFieldValue(`number_series.${field}`, value);
        } else {
            toast.error('Номер и серия могут содержать только буквы (латиница/кириллица), слеш, тире и нижнее подчеркивание');
        }
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            ...initialValuesDepositsOrCertificate(activeItem, count, userId),
            // eslint-disable-next-line no-nested-ternary
            resource: activeItem ? (activeSideBarItem === SIDEBAR_TYPES.WAVE ? (activeItem.count_people ?? activeItem.rent_pay_count) : activeItem.minutes) : undefined,
            sessionTimeoutSecs: 
                activeItem && convertTimeToIntegerMinutes(definePayLinkTtl(activeItem)),
            number_series: {
                number: '',
                series: ''
            },
            set_number_series: false,
        },
        onSubmit: (values) => console.log(values)
    });
    const {price, price_stock, price_total} = priceInfo(formik, count);

    const checkStock = async () => {
        if (formik.values.promo_code) checkPromoCode(formik, date, formik.values.promo_code, currentUser);
        if (formik.values.automatic_stock) checkAutomaticStockOrder(formik, date, currentUser);
        /**
         * TODO Поправить as после типизации Formik
         */
        if (formik.values.manual_stock) checkManualStockOrder(formik, formik.values.manual_stock as TLabelAndValue, currentUser, activeHeaderItem);
    };

    const payOnline = () => {
        if(formik.values.set_number_series) {
            const {number, series} = formik.values.number_series;

            if(!number || !series) {
                toast.error('Задайте номер и серию сертификата или отключите соответствующий селектор');
                return;
            }

            if (!validateCertificateNumber(number) || !validateCertificateNumber(series)) {
                toast.error('Номер и серия могут содержать только буквы (латиница/кириллица), слеш, тире и нижнее подчеркивание');
                return;
            }
        }
        toggleFlagSpinner();
        try {
            handleClickOnline(formik);
        } finally {
            toggleFlagSpinner();
        }
    };

    const setNumberSeries = () => {
        const newState = !formik.values.set_number_series;
        if(!newState) {
            formik.setFieldValue('number_series.number', '');
            formik.setFieldValue('number_series.series', '');
        }
        formik.setFieldValue('set_number_series', newState);
    };

    useEffect(() => {
        if(count > 1 && formik.values.set_number_series) {
            formik.setFieldValue('set_number_series', false);
            formik.setFieldValue('number_series.number', '');
            formik.setFieldValue('number_series.series', '');
        }
    }, [count]);

    return (
        <div className={styles['basket']}>
            {!activeItem ?
                <div className={styles['basket--empty']}>
                    <div>Выберите сертификат, депозит или услугу<br/> из списка</div>
                </div>
                :
                <>
                    <div>
                        <div className={cn({
                            'basket--selected': true,
                            'basket--selected-price': activeSideBarItem === TYPES_DEPOSITS.MONEY
                        })}>
                            Выбор: {(Math.trunc(activeItem.price || activeItem.default_price) * count).toLocaleString()} ₽
                        </div>
                        <div className={styles['payment--block']}>
                            {activeSideBarItem !== TYPES_DEPOSITS.MONEY &&
                            <div className={styles['discount']}>
                              <div className={styles['discount--item']}>
                                <div className={styles['discount-status']}>
                                    <Switcher
                                        label='Скидка:'
                                        checked={formik.values.discount}
                                        onGx-change={() => {
                                            formik.setFieldValue('discount', !formik.values.discount)
                                        }}
                                    />
                                </div>
                                {formik.values.discount &&
                                <div className={styles['discount--item']}>
                                  <>
                                    <ManualStock
                                      classNameBlock={styles['discount--select']}
                                      user_id={userId}
                                      type='deposit'
                                      side={typeOrder}
                                      tariff_rate={formik.values.tariff_rate.id}
                                      value={formik.values.manual_stock}
                                      activeSideBarItem={activeSideBarItem}
                                      activeHeaderItem={activeHeaderItem}
                                      onChangeSelect={(e) => {
                                          formik.setFieldValue('manual_stock', e);
                                          if (e) {
                                              checkManualStockOrder(formik, e, currentUser, activeHeaderItem);
                                              setStockInfo(e);
                                          } else {
                                              formik.setFieldValue('stock', undefined);
                                              formik.setFieldValue('price_stock', 0);
                                          }
                                      }}
                                      isDisabled={false}
                                    />
                                  </>
                                </div>
                                }
                                </div>
                                {activeHeaderItem === TYPES.CERTIFICATES &&
                                <>
                                    <div className={cn(styles['discount--item'], styles['discount--item__bordered--top'])}>
                                    <div className={cn(styles['discount-status'], styles['discount--item__bordered--bottom'])}>
                                        <Switcher
                                        label='Дополнительно:'
                                        checked={formik.values.other}
                                        onGx-change={() => formik.setFieldValue('other', !formik.values.other)}
                                        />
                                        {formik.values.other &&
                                            <div className={styles['group']}>
                                                <div className={styles['total--item']}>
                                                    <span className={styles['total--label']}>Партия:</span>
                                                    <span className={styles['total--price']}>
                                                        <Input
                                                            value={formik.values.certificate_party}
                                                            name='certificate_party'
                                                            className={styles['total--input']}
                                                            onGx-input={(e: Record<string, any>) => {
                                                                formik.setFieldValue('certificate_party', e.target.value);
                                                            }}
                                                        />
                                                    </span>
                                                </div>
                                                <div className={styles['total--item']}>
                                                    <span className={styles['total--label']}>Комментарий:</span>
                                                    <span className={styles['total--price']} style={{width: '100%'}}>
                                                        <GxTextarea
                                                            value={formik.values.comment}
                                                            resize='none'
                                                            name='comment'
                                                            style={{width: '100%'}}
                                                            className={styles['total--textarea']}
                                                            onGx-input={(e: Record<string, any>) => {
                                                                formik.setFieldValue('comment', e.target.value);
                                                            }}
                                                        />
                                                    </span>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    </div>
                                    <div className={cn(styles['discount-status'], styles['discount--item__bordered--bottom'])}>
                                        <Switcher
                                        label='Задать номер и серию'
                                        checked={formik.values.set_number_series}
                                        onGx-change={setNumberSeries}
                                        disabled={count > 1}
                                        />
                                    {formik.values.set_number_series && <div>
                                        <div className={styles['sertificate-number']}>
                                            <div className={styles['sertificate-number__title']}>Номер:</div>
                                            <Input
                                                className={styles['sertificate-number--first']}
                                                size='small'
                                                onGx-input={(e: any) => handleNumberSeriesChange('number', e.target.value)}
                                                value={formik.values.number_series.number || ''}
                                            />
                                            <Input
                                                className={styles['sertificate-number--second']}
                                                size='small'
                                                onGx-input={(e: any) => handleNumberSeriesChange('series', e.target.value)}
                                                value={formik.values.number_series.series || ''}
                                            />
                                        </div>
                                    </div>}
                                    </div>
                                </>
                                }
                        </div>
                        }
                            <>
                                <div className={styles['payment--type']}>

                                    <Radio name="is-pay" className={styles['payment--type-radio']}
                                           checked={formik.values.is_pay_here}
                                           onClick={() => formik.setFieldValue('is_pay_here', true)}
                                    >
                                        Оплата на месте
                                    </Radio>
                                    <Radio name="is-pay" className={styles['payment--type-radio']}
                                           checked={!formik.values.is_pay_here}
                                           onClick={() => formik.setFieldValue('is_pay_here', false)}>Онлайн</Radio>
                                </div>
                                {formik.values.is_pay_here ?
                                    <>
                                        {
                                            flagSpinner ? <GxSpinner style={{fontSize: '2rem'}}/> :
                                                <Button disable={!activeItem} className={styles['payment--btn']}
                                                        onClick={payHere} theme='btn--outline_blue'
                                                        type='button'>Оплатить</Button>
                                        }
                                    </>
                                    :
                                    <div>
                                        <div className={styles['expired-block']}>
                                            <div className={styles['expired-block--title']}>
                                                Действие ссылки:
                                            </div>
                                            <div className={styles['expired-block--minutes-wrap']}>
                                                <InputNumbers className={styles['expired-block--inp']}
                                                              onKeyPress={handleOnPressKey}
                                                              handleInput={(e: any) => formik.setFieldValue('sessionTimeoutSecs', e.target.value)}
                                                              value={formik.values.sessionTimeoutSecs}/>
                                            </div>
                                            <div className={styles['expired-block--minutes']}>
                                                мин
                                            </div>
                                        </div>
                                        {!formik.values.is_pay_here && isBill.flag &&
                                        <div className={styles['bill-block']}>
                                          <div className={styles['bill-block--clipboard']}>
                                            <Clipboard value={isBill.link}/>
                                          </div>
                                        </div>
                                        }
                                        {!isBill.flag &&
                                        <Button onClick={() => {
                                            payOnline();
                                        }} className={styles['payment--btn']} theme='btn--outline_blue' type='button'>Выставить
                                            счет</Button>
                                        }
                                    </div>
                                }
                            </>
                            <div className={styles['pay-info']}>
                                <div className={styles['total']}>
                                    {(activeSideBarItem !== TYPES_DEPOSITS.MONEY && activeHeaderItem !== TYPES.CERTIFICATES) &&
                                    <div className={styles['total--item']}>
                                      <span className={styles['total--label']}>Ресурс:</span>
                                      <span className={styles['total--price']}>
                                         <span className={styles['count']}>{`${count} x`}</span>
                                        <InputNumbers
                                          disabled={currentUser.user_status !== TYPE_USER.SUPERUSER }
                                          value={formik.values.resource}
                                          name='resource'
                                            // value={(activeSideBarItem === TYPES_DEPOSITS.PIPE ? Math.trunc(activeItem.minutes): Math.trunc(activeItem.count_people) * count).toLocaleString()}
                                          className={styles['total--input']}
                                          onGx-input={(e: Record<string, any>) => {
                                              formik.setFieldValue('resource', Math.abs(Math.trunc(e.target.value)));
                                          }}
                                        />
                                      </span>
                                      <span
                                        className={styles['total--after-input']}>
                                            {activeSideBarItem === SIDEBAR_TYPES.WAVE 
                                            ? activeItem.rent_pay_count ? 'ap.' : 'сет' 
                                            : 'мин.'}
                                      </span>
                                    </div>
                                    }
                                    <div className={styles['total--item']}>
                                        <span className={styles['total--label']}>Сумма заказа:</span>
                                        {/* 
                                          *  TODO: Добавление отображения количества заказываемых услуг
                                          */}
                                        {activeHeaderItem !== TYPES.SERVICES && <span className={styles['count']}>{`${count} x`}</span>}
                                        <label htmlFor="promo_code" className={cn(styles['promocode--group'], styles['total--check'])}>
                                            <InputNumbers
                                                name="base_price"
                                                clearable={currentUser.user_status === TYPE_USER.SUPERUSER}
                                                className={styles['promocode--input']}
                                                value={String(price)}
                                                onKeyPress={handleOnPressKey}
                                                disabled={currentUser.user_status !== TYPE_USER.SUPERUSER && activeSideBarItem !== TYPES_DEPOSITS.MONEY}
                                                style={{width: 120}}
                                                onGx-input={(e: Record<string, any>) => {
                                                    formik.setFieldValue('base_price', Math.abs(Math.trunc(e.target.value)));
                                                    formik.setFieldValue('price_stock', 0);
                                                }}
                                                onGx-clear={() => {
                                                    formik.setFieldValue('base_price', formik.values.tariff_rate.price);
                                                }}
                                            />
                                            <GxButton onClick={checkStock}
                                                      className={styles['promocode--btn']}
                                                      disabled={(currentUser.user_status !== TYPE_USER.SUPERUSER || !stockInfo)}>
                                                <GxIcon className={styles['promocode--btn-icon']} src={IndicatorIcon}/>
                                            </GxButton>
                                        </label>
                                    </div>
                                    <div className={cn(styles['total--item'], styles['total--item_discount'])}>
                                        <span className={styles['total--label']}>Скидка:</span>
                                        <span
                                            className={styles['total--price']} style={{marginLeft: 30}}>{price_stock.toLocaleString()} ₽</span>
                                    </div>
                                    <div className={cn(styles['total--item'])}>
                                        <span className={styles['total--label']}>К оплате:</span>
                                        <span
                                            className={styles['total--price']} style={{marginLeft: 30}}>{price_total.toLocaleString()} ₽</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles['bottom']}>
                        <Button className={styles['bottom--btn']} onClick={modalClose}>
                            Закрыть
                        </Button>
                    </div>
                </>
            }
        </div>
    );
};

export default Basket;